<template>
    <div class="the-box">
      <div v-show="!isShowSuccess">
        <h4>The Data Diagnostic is an easy way to see the accuracy of your postal, phone, and email data, and the business case for refreshing your data.
          <br><i>Requires a minimum of 10,000 records.</i></h4>
        <div class="col-sm-7" style="padding-left: 0; padding-right: 0;">
          <h1>How it Works</h1>
          <h4>1. Send us a file of 10,000 – 25,000 records containing a first name, last name, address, city, state, zip code, phone number (optional), and email address (optional).</h4>
          <h4>2. We analyze the postal, email, and phone data and provide you with your Data Diagnostic report within 2-3 business days. <a href="/DHA_v7.pdf" target="_blank">View Sample Report</a></h4>
          <h4>3. Our Data team will schedule a call to review the report findings with you.</h4>
          <br>
          <h4>Have questions or interested in getting started? Complete the form below.</h4>
          <b-form-group>
            <b-form-input placeholder="First Name *" :state="this.infoValid.fname.state" v-model="firstname"/>
            <span v-if="infoValid.fname.text" class="text-danger">{{infoValid.fname.text}}</span>
          </b-form-group>
          <b-form-group>
            <b-form-input placeholder="Last Name *" :state="this.infoValid.lname.state" v-model="lastname"/>
            <span v-if="infoValid.lname.text" class="text-danger">{{infoValid.lname.text}}</span>
          </b-form-group>
          <b-form-group>
            <b-form-input placeholder="Company Name" v-model="info.company"/>
          </b-form-group>
          <b-form-group>
            <b-form-input placeholder="Email Address *" :state="this.infoValid.email.state" type="email" v-model="tempemail"/>
            <span v-if="infoValid.email.text" class="text-danger">{{infoValid.email.text}}</span>
          </b-form-group>
          <b-form-group>
            <b-form-input placeholder="Qty of Records in Database" v-model="info.qty"/>
          </b-form-group>
          <b-form-group>
            <b-form-textarea :rows="3" placeholder="Questions/Comments *" :state="this.infoValid.message.state" v-model="info.message"/>
            <span v-if="infoValid.message.text" class="text-danger">{{infoValid.message.text}}</span>
          </b-form-group>
          <div class="form-group" style="text-align: left;font-size: 12px;">
            <label><i>* Required</i></label>
          </div>
        </div>
        <div class="col-sm-5" style="padding-left: 0; padding-right: 0;"></div>

        <b-row>
          <div class="col-sm-7">
            <b-col class="colcenter">
              <b-btn :disabled="btnDisable" @click="submit">CONTACT US</b-btn>
            </b-col>
          </div>
          <div class="col-sm-5">
            <b-col class="colcenter">
              <b-btn :disabled="btnDisable" @click="showDemo">VIEW SAMPLE REPORT</b-btn>
            </b-col>
          </div>

        </b-row>
      </div>
      <div v-show="isShowSuccess" class="colcenter">
        <b-row>
          <b-col>
            <h1>Thanks for contacting us!</h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h3>We will get back to you very soon.</h3>
          </b-col>
        </b-row>
      </div>
      </b-container>
    </div>
</template>

<script>
  import notification from '@/components/common/notification'

  export default {
    data () {
      return {
        info: {
          fname: '',
          lname: '',
          company: '',
          email: '',
          qty: '',
          message: ''
        },
        btnDisable: false,
        infoValid: {
          fname: {
            state: null,
            text: ''
          },
          lname: {
            state: null,
            text: ''
          },
          email: {
            state: null,
            text: ''
          },
          message: {
            state: null,
            text: ''
          }
        },
        isShowSuccess: false
      }
    },
    computed: {
      firstname: {
        get () {
          return this.$store.getters['user/userInfo'].FirstName
        },
        set (val) {
          this.info.fname = val
        }
      },
      lastname: {
        get () {
          return this.$store.getters['user/userInfo'].LastName
        },
        set (val) {
          this.info.lname = val
        }
      },
      tempemail: {
        get () {
          return this.$store.getters['user/userInfo'].Email
        },
        set (val) {
          this.info.email = val
        }
      }
    },
    mounted () {
      this.load()
    },
    methods: {
      submit () {
        this.clearValid(this.infoValid)
        let that = this
        if (this.validInfo()) {
          this.btnDisable = true
          this.$http.post(this.$store.getters['config/link']('sendMessage'), {
            Action: 'save-contact-info',
            FormData: JSON.stringify({
              FirstName: this.info.fname,
              LastName: this.info.lname,
              Company: this.info.company,
              Email: this.info.email,
              Phone: '',
              Comment: this.info.message,
              Page: this.info.qty,
              PageInfo: window.location.hostname === 'dev.sl360.com' ? '[Staging] Data Diagnostic Inquiry' : 'Data Diagnostic Inquiry',
              FromSite: 'sl360.com',
              Source: 'Data-Diagnostic'
            })
          }, {
            emulateJSON: true
          }).then(resp => {
            that.btnDisable = false
            if (resp.body.Status === 1) {
              that.isShowSuccess = true
              // notification.notice('error', 'Failed to sent contact information , please try again')
            }
          }, resp => {
            notification.notice('error', 'Failed to sent contact information , please try again')
            this.btnDisable = false
          })
        }
      },
      showDemo () {
        window.open('/DHA_v7.pdf')
      },
      validInfo () {
        let isValid = true
        if (!this.info.fname) {
          this.infoValid.fname.state = false
          this.infoValid.fname.text = "It's required"
          isValid = false
        }
        if (!this.info.lname) {
          this.infoValid.lname.state = false
          this.infoValid.lname.text = "It's required"
          isValid = false
        }
        if (!(this.info.email.indexOf('@') > 0 && this.info.email.indexOf('@') < this.info.email.length - 1)) {
          this.infoValid.email.state = false
          this.infoValid.email.text = 'E-mail must be valid'
          isValid = false
        }
        if (!this.info.email) {
          this.infoValid.email.state = false
          this.infoValid.email.text = "It's required"
          isValid = false
        }
        if (!this.info.message) {
          this.infoValid.message.state = false
          this.infoValid.message.text = "It's required"
          isValid = false
        }
        return isValid
      },
      clearValid (items) {
        for (let key in items) {
          items[key].state = null
          items[key].text = false
        }
      },
      load () {
        this.info.fname = this.$store.getters['user/userInfo'].FirstName
        this.info.lname = this.$store.getters['user/userInfo'].LastName
        this.info.email = this.$store.getters['user/userInfo'].Email
        this.isShowSuccess = false
      }
    }
  }
</script>

<style scoped>
  .the-box {
    background-color: #fff;
    padding: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/FreeDataDiagnostic.vue